import {
    BuscarCategoriasVendaUauService,
    BuscarClienteCompletoService,
    GetVendaService,
    ListarAnexosVendaService,
    ListarClienteCompletoService,
    ListarCobrancasService,
    ListarEscriturasService,
    VerificarInadimplenciaProdutoService,
    getInforVendasService,
} from "../../../Services/Geral/InformacoesVenda/InformacoesVendaServices";
import { Controller } from "../../Controller";

export function ListarEscriturasController(codigoStatusEscritura: string) {
    return Controller(ListarEscriturasService(codigoStatusEscritura));
}

export function ListarCobrancasController(codigoStatusCobranca: string) {
    return Controller(ListarCobrancasService(codigoStatusCobranca));
}

export function GetVendaController(ID_CHAVE_ERP: string) {
    return Controller(GetVendaService(ID_CHAVE_ERP));
}

export function ListarAnexosVendaController(ID_CHAVE_ERP: string) {
    return Controller(ListarAnexosVendaService(ID_CHAVE_ERP)).then((res) =>
        res.map((a, index) => ({
            ...a,
            key: index,
        }))
    );
}

export function BuscarCategoriasVendaUauController(idContaProduto: number) {
    return Controller(BuscarCategoriasVendaUauService(idContaProduto));
}

export function VerificarInadimplenciaProdutoController(idCaso: number) {
    return Controller(VerificarInadimplenciaProdutoService(idCaso));
}

export function getInforVendasController(ID_CASO: number) {
    return Controller(getInforVendasService(ID_CASO));
}

export function BuscarClienteCompletoController(ID_CHAVE_ERP: string) {
    return Controller(BuscarClienteCompletoService(ID_CHAVE_ERP));
}

export function ListarClienteCompletoController(DS_NOME: string) {
    return Controller(ListarClienteCompletoService(DS_NOME));
}
